module.exports = __webpack_public_path__ + "static/media/icon-dashboard-incomplete.64c947d9.svg";